<template>
  <div class="sf-flash-manager__container" data-testid="sf-flash-manager">
    <SfBannerSystem
      v-for="({ variant, text }, index) in bannerList"
      :key="`${text}-${variant}`"
      :variant="variant"
      :show-close="true"
      @close="close(index)"
    >
      {{ text }}
    </SfBannerSystem>
  </div>
</template>

<script lang="ts" setup>
import { type SilverfinFlash } from '@app/types'

import { ref, onMounted, onBeforeUnmount } from 'vue'

import { messageTypeToVariant, MessageTypeToVariantType } from './constants'
import SfBannerSystem from '@app/shared/vue/components/sf-banner/sf-banner-system.vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfFlashManager',
})

type Banner = {
  variant: MessageTypeToVariantType
  text: string
}

const bannerList = ref<Banner[]>([])

const addBanner: SilverfinFlash['addFlash'] = (type, text) => {
  const variant = messageTypeToVariant[type]

  const alreadyExists = bannerList.value.some(
    (banner) => banner.variant === variant && banner.text === text
  )

  if (!alreadyExists) {
    bannerList.value.push({ variant, text })
  }
}

const addBanners: SilverfinFlash['setFlashMessages'] = (banners) => {
  banners.forEach((banner) => addBanner(banner[0], banner[1]))
}

const close = (index: number) => {
  bannerList.value.splice(index, 1)
}

onMounted(() => {
  window.eventHub.$on('sf-flash-manager:add-banner', addBanners)
  window.eventHub.$on('sf-flash-manager:add-banners', addBanners)
})

onBeforeUnmount(() => {
  window.eventHub.$off('sf-flash-manager:add-banner', addBanners)
  window.eventHub.$off('sf-flash-manager:add-banners', addBanners)
})
</script>
